<template>
    <div class="chkdList">
        <list :collapseItem="collapseItem" :url="url"></list>
    </div>
</template>
<script>
import list from "../../components/cklist";
export default {
    name: "chkdList",
    data() {
        return {
            collapseItem: [
                // { title: "来源数据库", name: 1 },
                { title: "主题词类别", name: 2 },
                { title: "学科类别", name: 3 },
                { title: "研究资助基金", name: 4 },
                { title: "文献作者", name: 5 },
                { title: "作者单位", name: 6 },
                { title: "发表年份", name: 7 }
            ],
            url: "chkd"
        };
    },
    components: {
        list
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "中国医院知识总库(CHKD)", iconType: true });
    },
    beforeRouteLeave(to, from, next) {
        //   进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "chkdDetails") {
            if (!from.meta.keepAlive) {
                from.meta.keepAlive = true; // 当我们进入到C时开启B的缓存
            }
            to.meta.keepAlive = true; // 当我们进入到C时开启B的缓存
            next();
        } else {
            from.meta.keepAlive = false;
            //   this.$vnode.parent.componentInstance.cache = {};
            //   this.$vnode.parent.componentInstance.keys = [];
            this.$destroy();
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>
<style lang="less">
.van-collapse-item__content {
    padding: 0 16px !important;
    background: #f7f7f7;

    .van-cell {
        background: #f7f7f7;
    }
}

.van-popup {
    > .van-cell {
        font-size: 0.8rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-bottom: 1px solid #e4e4e4;
    }
}

.chkdList {
    margin-top: 0.8rem;

    > div {
        .van-row {
            border-bottom: 1px solid #e3e3e3;
            height: 2.5rem;
            padding: 0.7rem 0;
            background: #fff;

            .van-col--12 {
                color: #0c60a3;
                text-align: center;
            }
        }

        > p {
            font-size: 0.7rem;
            padding: 0.8rem 1rem;
            color: #b0b0b0;
            background: #fff;
        }

        .listCon {
            margin-top: 0.8rem;
            background: #fff;

            > p {
                padding: 1rem 1rem 0 1rem;
                color: #9a9a9a;
            }

            .van-list {
                .con {
                    border-bottom: 1px solid #e3e3e3;
                    padding: 1rem;

                    h4 {
                        a {
                            color: #0c60a3;
                        }

                        font-weight: 400;
                    }

                    p {
                        margin-bottom: 0.4rem;

                        span {
                            color: #9a9a9a;
                        }
                    }
                }
            }
        }
    }
}
</style>
